module.exports = "<modal-dialog>\n  <h4 class=\"modal-title\" modal-header>\n    Provide Reasons For Cancellation\n  </h4>\n  <div modal-body>\n    <textarea  [(ngModel)]=\"cancellationReason\" style=\"width:100%\"> </textarea>\n  </div>\n  <div modal-footer>\n    <button class=\"btn btn-primary btn-md\" (click)=\"submit(cancellationReason)\">Submit</button>\n    <button class=\"btn btn-default btn-md\" (click)=\"cancel()\">Cancel</button>\n  </div>\n</modal-dialog>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dialog/dialog.component.html
// module id = ./src/app/shared/dialog/dialog.component.html
// module chunks = main